import React from 'react';
import { useDispatch } from 'react-redux';
import { SIDEBAR_ACTIONS } from '../../../constants/actionsConstants';
import RightModalHeader from './RightModalHeader';
import RightModalFooter from './RightModalFooter';

const RightModalLayout = ({
  children,
  title,
  caption,
  className,
  submitLabel,
  cancelLabel,
  submitAction,
  cancelAction,
  closeAction,
  showBackButton,
  submitDisabled,
  cancelDisabled,
  submitTooltip,
  footerVariant = 'HORIZONTAL',
  footerClassName = '',
  editable
}) => {
  const dispatch = useDispatch();

  const onClose = () => {
    if (closeAction) {
      closeAction();
    } else {
      dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
    }
  };

  return (
    <div className="tw-wrapper tw-flex tw-flex-col tw-h-screen">
      <RightModalHeader
        title={title}
        caption={caption}
        showBackButton={showBackButton}
        onClose={onClose}
        editable={editable}
      />
      <div className="tw-flex-1 tw-overflow-auto tw-p-6">
        <div className={`tw-flex tw-flex-col tw-flex-1 tw-space-y-4 ${className}`}>
          {children}
        </div>
      </div>
      <RightModalFooter
        footerVariant={footerVariant}
        cancelLabel={cancelLabel}
        cancelAction={cancelAction}
        cancelDisabled={cancelDisabled}
        submitLabel={submitLabel}
        submitAction={submitAction}
        submitDisabled={submitDisabled}
        submitTooltip={submitTooltip}
        footerClassName={footerClassName}
      />
    </div>
  );
};

export default RightModalLayout;
